import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface GeneralMetalProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const GeneralMetal: React.FC<GeneralMetalProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [generalMetal, set_generalMetal] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Framing']?.['General Metal, Steel'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Framing': { ...b.values?.['Framing'], 'General Metal, Steel': v } } })
    );
    const label = 'General Metal, Steel';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(generalMetal)}
                />
            ) : (
                <MoneyBox
                    id={'generalMetal'}
                    allowNegative={false}
                    value={generalMetal}
                    onChange={(value) => set_generalMetal(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
